import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { Add } from '@mui/icons-material';

const HeaderLinks = ({ onAdd, onAddBulk }) => {
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        fontSize='medium'
        color='transparent'
        tooltip={t('Tooltips.DocumentTemplate.AddNewBulkDocumentTemplate')}
        onClick={onAddBulk}
      >
        <Add color='warning' />
      </IconButton>
      <IconButton
        type='add'
        fontSize='medium'
        color='transparent'
        tooltip={t('Tooltips.DocumentTemplate.AddNewDocumentTemplate')}
        onClick={onAdd}
      />
    </>
  );
};
HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onAddBulk: PropTypes.func.isRequired
};

export default HeaderLinks;
